import React, { useState } from "react";
import { Button } from "react-bootstrap"
import Logo2 from "../../assets/images/BPPMHKP.png";
import './styles/landing.css';
import { useNavigate } from "react-router-dom";
import {FaSearch} from "react-icons/fa";

const Navigation = () => {
  const [activeLink, setActiveLink] = useState("#features");

  const handleSetActive = (hash) => {
  if (hash === "#header") {
    setActiveLink(null); 
  } else {
    setActiveLink(hash);
  }
};;
 const navigate = useNavigate(); 

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light fixed-top">
      <div className="container">
        <a className="navbar-brand" 
            href="#header" 
            style={{ display: 'flex', alignItems: 'center',fontWeight: 'bold', fontSize: '2rem'}}
            onClick={() => handleSetActive("#header")} >
              
          <img 
            src={Logo2}
            className="img-responsive" 
            style={{ width: '80px', marginRight: '10px', }}
            alt="Logo"
          />
          Badan Mutu KKP
        </a>
        
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="true"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto"> 
            <li className="nav-item " style={{ marginLeft: "20px" }}>
              <a 
                className={`nav-link ${activeLink === "#features" ? "active" : ""}`}
                href="#features"
                onClick={() => handleSetActive("#features")}
              >
                Fitur
              </a>
            </li>
            <li className="nav-item" style={{ marginLeft: "20px" }}>
              <a 
                className={`nav-link ${activeLink === "#about" ? "active" : ""}`}
                href="#about"
                onClick={() => handleSetActive("#about")}
              >
                Tentang
              </a>
            </li>
            <li className="nav-item" style={{ marginLeft: "20px" }}>
              <a 
                className={`nav-link ${activeLink === "#services" ? "active" : ""}`}
                href="#services"
                onClick={() => handleSetActive("#services")}
              >
                Tugas
              </a>
            </li>
            <li className="nav-item" style={{ marginLeft: "20px" }}>
              <Button 
                as="a"
                className="nav-link"
                onClick={() => navigate("/val-smkhp")}
                type="button"  
                style={{
                  background: "transparent",
                  border: "1px solid #59cee2", 
                  color: "#242222",           
                  borderRadius: "6px",         
                  padding: "6px 16px"
                }}
              > <i className="fa fa-search" style={{ marginRight: "5px" }}></i>
                 Penelusuran SMKHP
              </Button>
            </li>
           <li className="nav-item" style={{ marginLeft: "20px" }}>
              <Button as="a"
                className={`nav-link `}
                onClick={() => navigate("/login")}
                type="button"  
                style={{
                  background: "#006fd6",
                  border: "1px solid #59cee2", 
                  color: "#ffffff",            
                  borderRadius: "6px",       
                  padding: "6px 16px"
                 
                }}

                // type="button"  variant="btn btn-primary"
              >
                Login
              </Button>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
